import React from 'react'
import './WhyHireUs.css'
import WhuImg from '../../../../assets/img/whu.webp'
import pd from '../../../../assets/img/project_delivered.svg'
import hc from '../../../../assets/img/happy_clients.svg'
import tc from '../../../../assets/img/coffee.svg'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function WhyHIreUs() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='ffr-sec'>
                <div className='ffr-head'>
                    <h3>Elevate User </h3>
                    <h4>Experience with Our Services</h4>
                </div>
                <div className='ffr-desc'>
                    <p>We provide modern mobile app development services that exceed market standards and elevate user experiences.</p>
                    <h5>Shaping Digital Success with Expertise</h5>
                    <p>Our specialized mobile development and consulting services cater to startups, mid-scale businesses, and large enterprises, helping them achieve outstanding results and exceptional </p>
                </div>
            </div>
            <div className='whu-sec1'>
                <div className='whulft'></div>
                <div className='whurgt'>
                    <h3>How Profitable Is Developing An App For Your Business?</h3>
                    <p>Did you know that the app market is projected to generate $756 billion in revenue by 2027. A well-designed app offers multiple monetization options, including in-app purchases, subscriptions, advertisements, and data monetization, enhancing your revenue streams. Partnering with a reputable development company like 360-Bytes ensures a high-quality product tailored to your business goals, maximizing your app’s profitability. ROI.</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyHIreUs
